import React from 'react';

import { useHistory } from 'react-router';

import browserTab from 'assets/images/browser-tab.png';
import Button from 'components/shared/Button';
import { DASHBOARD_PATH } from 'constants/routes';
import { useAccountPath } from 'hooks/useAccountPath';
import { useModalClose } from 'hooks/useModalClose';

import ModalWrapper from '../index';
import cs from '../index.module.css';
import s from './index.module.css';

const MultipleTabsModal = ({ onClose }: { onClose: () => void }) => {
  useModalClose();

  const getPath = useAccountPath();
  const history = useHistory();
  const handleExit = () => {
    onClose();
    history.push(getPath(DASHBOARD_PATH));
  };

  return (
    <ModalWrapper
      onClose={onClose}
      header="Multiple Tabs Detected"
      body={
        <>
          <div className={s.imageWrapper}>
            <img className={s.image} src={browserTab} alt="Another browser tab" />
          </div>
          <div className={s.content}>
            <div className={s.title}>It looks like this itinerary is open in another browser tab.</div>
            <div className={cs.description}>
              Please note that if changes are made in another tab or window — either by yourself or by a colleague, they
              will override any progress you make here, and vice versa.
              <br />
              <br />
              To ensure your work is saved correctly, we recommend working in only one tab at a time.
            </div>
          </div>
        </>
      }
      footer={
        <>
          <Button type="default" size="medium" onClick={handleExit}>
            Exit Itinerary
          </Button>
          <Button size="medium" onClick={onClose}>
            Continue
          </Button>
        </>
      }
    />
  );
};

export default MultipleTabsModal;
